import i18next from "i18next";
import { useQuery } from "react-query";
import { z } from "zod";
import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

export const CAS3_PROVIDERS_ENDPOINT = "/api/auth/cas3-providers" as const;

export const getAllCas3ProvidersKey = "getAllCas3Providers" as const;

export const Cas3ProviderSchema = z.object({
    "@id": z.string(),
    id: z.number(),
    providerName: z.string(),
    label: z.string().nullable().optional(),
    hostUrl: z.string(),
    loginUrl: z.string(),
    logoutUrl: z.string(),
    validationServiceUrl: z.string(),
    resourceOwnerMapping: z
        .record(z.string(), z.union([z.string(), z.array(z.string())]))
        .nullable()
        .optional(),
});

export type Cas3Provider = z.infer<typeof Cas3ProviderSchema>;

type Options = {
    enabled?: boolean;
};

export const useGetAllCas3Providers = (options?: Options) => {
    const query = useQuery({
        queryKey: [getAllCas3ProvidersKey, i18next.resolvedLanguage],
        enabled: options?.enabled ?? true,
        queryFn: async () => {
            return loggedInApiCall.get(CAS3_PROVIDERS_ENDPOINT, { params: { itemsPerPage: 100 } });
        },
        select: (request) => {
            const data = request.data["hydra:member"];
            return zodParseWithDetailedLog(data, Cas3ProviderSchema.array(), {
                operation: "GET",
                endpoint: CAS3_PROVIDERS_ENDPOINT,
            });
        },
    });

    return {
        cas3Providers: query.data,
        ...query,
    };
};
